import { render, staticRenderFns } from "./PwaConfig.vue?vue&type=template&id=64aeaa3c"
import script from "./PwaConfig.vue?vue&type=script&lang=js"
export * from "./PwaConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports